/**
 * Shared constants & helpers for the Activity Timeline (Eventi importanti).
 *
 * Colours map to each `category` returned by `/admin/timeline`. Used by:
 *   • chart-overlay dots (small filled circles)
 *   • category-filter chips
 *   • the dedicated Timeline page
 */

import {
  Send, Gift, Calendar, ShoppingBag, Settings, BookmarkPlus,
} from 'lucide-react';

export const CATEGORY_META = {
  communication: { color: '#3B82F6', label: 'Comunicazione', icon: Send },
  loyalty:       { color: '#D44E20', label: 'Loyalty',       icon: Gift },
  events:        { color: '#8B5CF6', label: 'Eventi',        icon: Calendar },
  retail:        { color: '#10B981', label: 'Shop',          icon: ShoppingBag },
  ops:           { color: '#F59E0B', label: 'Operativo',     icon: Settings },
  manual:        { color: '#64748B', label: 'Annotazione',   icon: BookmarkPlus },
};

export const ALL_CATEGORIES = Object.keys(CATEGORY_META);

/** Local-storage key for the on/off toggle (persists per browser). */
export const TIMELINE_VISIBILITY_KEY = 'lazo.timelineMarkers.enabled';

/**
 * Bucket a date into the same format used by the chart's X axis.
 * Returns the matching X key or `null` if the event is outside the
 * range covered by the chart.
 */
export function bucketDateMMDD(isoDate) {
  if (!isoDate) return null;
  try {
    const d = new Date(isoDate);
    if (Number.isNaN(d.getTime())) return null;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${mm}-${dd}`;
  } catch {
    return null;
  }
}

/** "YYYY-MM" — used by 12-month trend charts. */
export function bucketDateYearMonth(isoDate) {
  if (!isoDate) return null;
  try {
    const d = new Date(isoDate);
    if (Number.isNaN(d.getTime())) return null;
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  } catch {
    return null;
  }
}

/** Group events by chart bucket; returns Map<bucket, events[]>. */
export function groupEventsByBucket(events, bucketFn) {
  const map = new Map();
  (events || []).forEach((ev) => {
    const b = bucketFn(ev.occurred_at);
    if (!b) return;
    if (!map.has(b)) map.set(b, []);
    map.get(b).push(ev);
  });
  return map;
}
